import { render, staticRenderFns } from "./DashboardClientCorsOrigin.vue?vue&type=template&id=68c1d57c&"
import script from "./DashboardClientCorsOrigin.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientCorsOrigin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c1d57c')) {
      api.createRecord('68c1d57c', component.options)
    } else {
      api.reload('68c1d57c', component.options)
    }
    module.hot.accept("./DashboardClientCorsOrigin.vue?vue&type=template&id=68c1d57c&", function () {
      api.rerender('68c1d57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientCorsOrigin.vue"
export default component.exports